// Unpublished Work © 2025 Deere & Company.

import {reduceIsgToggles} from 'Common/utils/isg-toggles';
import {createUiAxiosClient} from 'Utils/ui-axios-client';

async function getIsgToggles(username, orgId) {
    const axiosClient = createUiAxiosClient();

    const response = await axiosClient.get('/isg-toggles', {
        params: {
            username,
            orgId
        }
    });

    return response.data?.toggles?.reduce(reduceIsgToggles, {}) || {};
}

export {
    getIsgToggles
};
